'use client'

import { useIsPunchout } from '@/lib/auth/client/AuthProvider.client'

export function useHasCart(cartId?: string | null): boolean {
  const isPunchout = useIsPunchout()

  return !!cartId || isPunchout
}
